export function capitalize(value: string): string {
    return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}

export function intval(value: string | null): number {
    if (value !== null) {
        return parseInt(value, 10);
    }
    return 0;
}

export function ucfirst(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function htmlDecode(input: string): string {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent ?? '';
}

export function generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const randomValues = new Uint32Array(length);

    window.crypto.getRandomValues(randomValues);
    randomValues.forEach(value => {
        result += characters.charAt(value % characters.length);
    });

    return result;
}
